module.exports = __webpack_public_path__ + "media/images/tiedye/design-3-9322db0ca8e5fc098f583c0085c23153.jpg";